module.exports = __webpack_public_path__ + "img/zerticarbon_green_logo.561f2c7b.png";